import multiApiClient from "./base";

export const KauflandArticlesApi = {
  // ── Cron ─────────────────────────────────────────────────────────────────
  startCronJob: (schedule = "0 8 * * *") =>
    multiApiClient.post("/kaufland/articles/cron/start", null, {
      params: { schedule },
    }),

  stopCronJob: () => multiApiClient.post("/kaufland/articles/cron/stop"),

  getCronStatus: () => multiApiClient.get("/kaufland/articles/cron/status"),

  // ── Recalculate ───────────────────────────────────────────────────────────
  recalculate: (sku) =>
    sku
      ? multiApiClient.post(
          `/kaufland/articles/recalculate/${encodeURIComponent(sku)}`,
        )
      : multiApiClient.post(`/kaufland/articles/recalculate`),

  // ── Send prices to Kaufland ───────────────────────────────────────────────
  sendMinimumPrices: (sku, storefront = null) =>
    multiApiClient.post(
      `/kaufland/articles/send_minimum_prices/${encodeURIComponent(sku)}`,
      null,
      { params: storefront ? { storefront } : {} },
    ),

  // ── Sync from Kaufland API ────────────────────────────────────────────────
  syncArticles: (storefront = "de", sku = null) =>
    multiApiClient.post(
      `/kaufland/articles/sync/${sku ? encodeURIComponent(sku) : "all"}`,
      null,
      { params: { storefront } },
    ),
};
